import { Collapse, Modal, Toast, Dropdown, Tab } from 'bootstrap';

/**
 *  files from theme
 */

//import "./components/swiper-configurations.js";
import mainNav from './components/mainNav';
import stickyBar from './components/stickyBar';
import swiper from './components/swiper';

try {
  // safety loader
  if (!window.$) {
    window.$ = window.jQuery = require('jquery');

  }

  document.addEventListener('DOMContentLoaded', () => {
    mainNav();
  });

  jQuery(document).ready(function($) {
    stickyBar();
    swiper();
  });
}
catch (e) {}
